export * from "./Signup";
export * from "./UserInfo";
export * from "./request";
export * from "./Application";
export * from "./OutputRequest";
export * from "./DataGrid";
export * from "./Ref";
export * from "./EXPERT";

if (process.env.NODE_ENV === "production") {
	window.__indexPageGrayMode = "$REACT_APP_INDEX_PAGE_GRAY_MODE";
}

export const isGrayMode = () =>
	process.env.NODE_ENV === "production"
		? window.__indexPageGrayMode === "true"
		: process.env.REACT_APP_INDEX_PAGE_GRAY_MODE === "true";
